// API Suffix required for running app locally
export const isProduction = process.env.NODE_ENV === 'production';
export const EnvironmentName = 'Prod'; //Test or Prod to change environment on car advisory service
export const baseUrlPrefix = process.env.NODE_ENV === 'production' ? '' : 'https://racqcm.localhost';
export const sitecoreApiKey = '{B63ACAB1-70AA-4474-AE94-7EF7A4F254F1}';
export const sitecoreApiKeyLocal = '{3DD77ADE-8CFA-4191-8CB7-B600DEC02385}';
const formsApiPrefix = `${baseUrlPrefix}/formsapi/v1`;

// car advisory apis
export const getSuggestions = `${formsApiPrefix}/caradvisory/getsuggestions?count={0}&searchTerm={1}&EnvironmentName=${EnvironmentName}`;
export const getMakes = `${formsApiPrefix}/caradvisory/getmakes?paginationToken={0}&EnvironmentName=${EnvironmentName}`;
export const getModelsByMake = `${formsApiPrefix}/caradvisory/getmodelsbymake?make={0}&paginationToken={1}&EnvironmentName=${EnvironmentName}`;
export const getTrimsByMakeAndModel = `${formsApiPrefix}/caradvisory/gettrimsbymakeandmodel?make={0}&model={1}&paginationToken={2}&EnvironmentName=${EnvironmentName}`;
export const getVehiclesBySearch = `${formsApiPrefix}/caradvisory/getvehiclesbysearch?EnvironmentName=${EnvironmentName}`;
export const getVehiclesBySearchGrouped = `${formsApiPrefix}/caradvisory/getvehiclesbysearchgrouped?EnvironmentName=${EnvironmentName}`;
export const getVehicleById = `${formsApiPrefix}/caradvisory/getvehiclebyid?id={0}&fields={1}&EnvironmentName=${EnvironmentName}`;
export const getVehicleImagesById = `${formsApiPrefix}/caradvisory/getvehicleimagesbyid?id={0}&EnvironmentName=${EnvironmentName}`;
export const fetchVehicleReviewsById = `${formsApiPrefix}/caradvisory/getvehiclereviewsbyid?id={0}&EnvironmentName=${EnvironmentName}`;
export const fetchVehicleReviewsBySearch = `${formsApiPrefix}/caradvisory/getreviewsbysearch?EnvironmentName=${EnvironmentName}`;
export const fetchReviewById = `${formsApiPrefix}/caradvisory/getreviewbyid?reviewId={0}&EnvironmentName=${EnvironmentName}`;
export const getVehicleGroupByTrimId = `${formsApiPrefix}/caradvisory/getvehiclegroupsbytrimid?id={0}&filterContext={1}&EnvironmentName=${EnvironmentName}`;

// dev QA API endpoint = https://pj306-dev-s10-cm-racq.racqgroup.local

// GraphQL datasource defaults
export const DefaultSearchResultsDatasourceId = '9819FFAFBB5F49E689D35CD8B4DD5BE0';
export const DefaultSearchWidgetDatasourceId = 'DF5A461D99C946438B6C78DE5741A85E';
export const DefaultCompareVehiclesDatasourceId = 'A18890AECD5440E4A7F8AE01BE038E9F';
export const DefaultCarDetailsDatasourceId = 'A1CBB1F725664AC2B82AE5EB632F96A2';

// GraphQL constants
export const ShareCopyDatasourceId = '1D9EAC75210C41AEB5FFDAA8C0CE37F6';
export const ComparisonFooterDatasourceId = '58608D7F03AB4D67BAAE7D8AECE7F52E';
export const MakeModelModalDatasourceId = '9898A874B60845FE94CDAF4B362DCDE6';

// Lookup item datasources
export const FuelPriceDatasourceId = 'EC29C4F1835F4A90B74B98D6EB8D8D76';
export const RegistrationCostsDatasourceId = '8B55ABBCC0334FA59E4164E269764DDA';

// Disclaimer and explanation Modal datasources
export const ModalDatasourcesFolderId = 'C6D502A0997F4F1BB7D0A148DC6FCF3A';
